import { Reducer } from 'redux';
import {
  IDriverReportQueueState,
  DriverReportQueueActionTypes,
} from '../types';
import { NotificationStatus } from '../../../../common/sharedTypes';

// Type-safe initialState!
const initialState: IDriverReportQueueState = {
  workflowItemSteps: [],
  openWorkflowItemStep: null,
  id: '',
};

const reducer: Reducer<IDriverReportQueueState> = (
  state = initialState,
  action
) => {
  //console.log('action', action);
  switch (action.type) {
    case DriverReportQueueActionTypes.SEARCH_REPORTS: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DriverReportQueueActionTypes.GET_REPORT_DATA: {
      let _state = { ...state };
      _state = { ...state, workflowItemSteps: action.value };
      return _state;
    }
    case DriverReportQueueActionTypes.OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DriverReportQueueActionTypes.ASSIGN_AND_OPEN_REPORT: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    case DriverReportQueueActionTypes.UNASSIGN: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      return _state;
    }
    case DriverReportQueueActionTypes.SAVE_DATA_TRANSCRIBE_VALIDATION: {
      let _state = { ...state };
      _state.workflowItemSteps = [
        ..._state.workflowItemSteps.map((item) =>
          item.id == action.value.id ? { ...item, ...action.value } : item
        ),
      ];
      _state.openWorkflowItemStep = action.value;
      return _state;
    }
    case DriverReportQueueActionTypes.COMPLETE_DATA_ENTRY: {
      let _state = { ...state };
      _state = { ...state, openWorkflowItemStep: action.value };
      return _state;
    }
    default: {
      return state;
    }
  }
};

export default reducer;
